import React, { useId, useState } from "react";
import "./Testimonials.scss";

const feedback = [
    {
        id: "migrart",
        date: "Apr 12, 2023",
        dateTime: "2023-04-12",
        text: "Working with Roy on the Migrart website development has been an amazing experience. His dedication and commitment throughout the project were incredible. We’re proud of him for understanding our vision and transforming it into a dynamic and user-friendly platform.\n\nWe also appreciated his quick communication and timely delivery. MigrArt is an online database platform for migrant artists based in Poland, fully financed by the city of Warsaw through STREFA WOLNOSŁOWA.\nThank you for your service.",
        firstName: "Stanley",
        lastName: "Ndua",
        title: "Coordinator, Migrart",
    },
    {
        id: "made-in-english",
        date: "Jan 10, 2022",
        dateTime: "2022-01-10",
        text: "Working with Roy to design my language school’s website was a fantastic experience. From the start, Roy understood my needs and created a modern, intuitive, and user-friendly site.",
        firstName: "Karina",
        lastName: "Radczuk",
        title: "Founder, Made In English",
    },
    {
        id: "slyzed",
        date: "Nov 1, 2025",
        dateTime: "2025-11-01",
        text: "Working with Techadive on the Slyzed mobile app was an outstanding experience. The team took the time to deeply understand our goals and delivered a sleek, user-friendly product that perfectly matched our vision.\n\nThe process was smooth from start to finish — clear communication, thoughtful design decisions, and quick turnaround times.\n\nThe final app not only looks fantastic but also provides our clients with a seamless, customizable e-commerce solution. We couldn’t be happier with the result!",
        firstName: "Julius",
        lastName: "Angwenyi",
        title: "Project Manager, Slyzed",
    },
];

const TestimonialText = ({ text, author, maxChars = 220 }) => {
    const [expanded, setExpanded] = useState(false);
    const textId = useId();
    const isLong = text.length > maxChars;

    // Avoid cutting through a word.
    const excerpt = text.slice(0, maxChars);
    const lastSpace = excerpt.lastIndexOf(" ");
    const shortenedText =
        lastSpace > 0 ? excerpt.slice(0, lastSpace) : excerpt;

    return (
        <div className="testimonials__quote">
            <blockquote id={textId} className="testimonials__text">
                {expanded || !isLong ? text : `${shortenedText}…`}
            </blockquote>

            {isLong && (
                <button
                    className="testimonials__read-more"
                    type="button"
                    aria-expanded={expanded}
                    aria-controls={textId}
                    onClick={() => setExpanded((previous) => !previous)}
                >
                    {expanded ? "Show less" : "Read full review"}
                    <span className="testimonials__sr-only">
            {` from ${author}`}
          </span>
                </button>
            )}
        </div>
    );
};

const Testimonials = () => {
    return (
        <section
            className="testimonials"
            id="testimonials"
            aria-labelledby="testimonials-title"
        >
            <div className="testimonials__inner">
                <div className="testimonials__header">
                    <p className="testimonials__eyebrow">Client Feedback</p>

                    <h2 id="testimonials-title">
                        What Our <span>Clients Say.</span>
                    </h2>
                </div>

                <ul className="testimonials__grid">
                    {feedback.map((review) => {
                        const name = `${review.firstName} ${review.lastName}`;

                        return (
                            <li key={review.id}>
                                <article
                                    className="testimonials__card"
                                    aria-label={`Review from ${name}`}
                                >
                                    <div className="testimonials__card-top">
                    <span
                        className="testimonials__quote-mark"
                        aria-hidden="true"
                    >
                      “
                    </span>

                                        <time
                                            className="testimonials__date"
                                            dateTime={review.dateTime}
                                        >
                                            {review.date}
                                        </time>
                                    </div>

                                    <TestimonialText text={review.text} author={name} />

                                    <div className="testimonials__author">
                    <span
                        className="testimonials__avatar"
                        aria-hidden="true"
                    >
                      {review.firstName.charAt(0)}
                        {review.lastName.charAt(0)}
                    </span>

                                        <div className="testimonials__author-details">
                                            <p className="testimonials__name">{name}</p>
                                            <p className="testimonials__role">{review.title}</p>
                                        </div>
                                    </div>
                                </article>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};

export default Testimonials;